import { SEASONS_SET, SEASONS_MERGE, SEASON_SET } from './constants';

export function setSeasons(data: Record<string, any>[]) {
    return {
        type: SEASONS_SET,
        payload: data,
        meta: {
            keyBy: 'id'
        }
    };
}

export function mergeSeasons(data: Record<string, any>[]) {
    return {
        type: SEASONS_MERGE,
        payload: data,
        meta: {
            keyBy: 'id'
        }
    };
}

export function setSeason(data: Record<string, any>) {
    return {
        type: SEASON_SET,
        payload: data
    };
}
